import CallToAction from './call-to-action.jsx';
import Category from './category.jsx';
import CirculatingSupply from './circulating-supply.jsx';
import Cryptocurrency from './cryptocurrency.jsx';
import HeldAmount from './held-amount.jsx';
import HeldValue from './held-value.jsx';
import LastUpdated from './last-updated.jsx';
import MarketCap from './market-cap.jsx';
import MarketCapRank from './market-cap-rank.jsx';
import Price from './price.jsx';
import PriceChange24h from './price-change-24h.jsx';
import PriceChange7d from './price-change-7d.jsx';
import PriceChange30d from './price-change-30d.jsx';
import PriceChange60d from './price-change-60d.jsx';
import PriceChange1y from './price-change-1y.jsx';
import Sparkline7d from './sparkline7d.jsx';
import Ticker from './ticker.jsx';
import TotalSupply from './total-supply.jsx';
import TradingVolume24h from './trading-volume-24h.jsx';
import Indicator from './indicator.jsx';
import Risk from './risk.jsx';
import Reward from './reward.jsx';
import CurrentUser from '@scripts/utilities/current-user.js';

// Each individual column object.
const callToAction = new CallToAction();
const category = new Category();
const circulatingSupply = new CirculatingSupply();
const cryptocurrency = new Cryptocurrency();
const heldAmount = new HeldAmount();
const heldValue = new HeldValue();
const lastUpdated = new LastUpdated();
const marketCap = new MarketCap();
const marketCapRank = new MarketCapRank();
const price = new Price();
const priceChange24h = new PriceChange24h();
const priceChange7d = new PriceChange7d();
const priceChange30d = new PriceChange30d();
const priceChange60d = new PriceChange60d();
const priceChange1y = new PriceChange1y();
const sparkline7d = new Sparkline7d();
const ticker = new Ticker();
const totalSupply = new TotalSupply();
const tradingVolume24h = new TradingVolume24h();
const indicator = new Indicator();
const risk = new Risk();
const reward = new Reward();

/**
 * Returns an ordered array of the columns in the table. Some columns are only
 * shown when including a member's portfolio in the table.
 */
const Columns = function(showPortfolio) {
  const columns = [];

  columns.push(marketCapRank);
  columns.push(cryptocurrency);
  columns.push(ticker);
  if (CurrentUser && CurrentUser.hasInsiderAccess) {
    columns.push(indicator);
    columns.push(risk);
  }
  if (CurrentUser && CurrentUser.hasProAccess) {
    columns.push(reward);
  }
  columns.push(category);
  if (showPortfolio) {
    columns.push(heldAmount);
  }
  columns.push(price);
  if (showPortfolio) {
    columns.push(heldValue);
  }
  columns.push(priceChange24h);
  columns.push(priceChange7d);
  columns.push(priceChange30d);
  columns.push(priceChange60d);
  columns.push(priceChange1y);
  columns.push(sparkline7d);
  columns.push(marketCap);
  columns.push(totalSupply);
  columns.push(circulatingSupply);
  columns.push(tradingVolume24h);
  columns.push(callToAction);
  columns.push(lastUpdated);


  return columns;
};


export default Columns;

